const Environment = {
    BASE_URL: import.meta.env.VITE_BASE_URL as string,
    SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN as string,
    ENV: import.meta.env.VITE_ENV as string,
    APP_VERSION: import.meta.env.VITE_APP_VERSION as string,
}

export default Environment
